import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=35333ab2"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports